import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import CustomButton from "components/Common/CustomButton";

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontWeight: 600,
  color: "#133933",
  fontSize: "14px",
  borderBottom: "1px solid #EAEAEA",
  padding: "10px 20px",
}));

// Row-level error popup for bulk upload validation failures.
export default function RowErrorDialog({ open, onClose, errors = [], message }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <StyledDialogTitle>Row Errors</StyledDialogTitle>
      <DialogContent sx={{ paddingTop: "1rem" }}>
        {message && (
          <Typography sx={{ marginBottom: "1rem", textAlign: "left", color: "#4F4F4F" }}>
            {message}
          </Typography>
        )}
        <TableContainer sx={{ maxHeight: "50vh" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>Row</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>ID</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Error</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {errors.map((err, index) => (
                <TableRow key={index}>
                  <TableCell>{err.row}</TableCell>
                  <TableCell>{err.id || "-"}</TableCell>
                  <TableCell>{err.message}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography sx={{ marginTop: "1rem", textAlign: "right" }}>
          <CustomButton variant="contained" onClick={onClose}>
            Close
          </CustomButton>
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
